import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store/store";
import BackArrowBlue from "../../../svg/back-arrow-blue";
import {
  generatePatientDataForPrimaryDetailsComponent,
  generatePatientDataForSinglePatient,
} from "../../../utils/generatePatientDataForSinglePatient";
import { PatientDetails } from "../../../data-model/PatientDetails";
import PatientPrimaryDetails from "./components/patientPrimaryDetails/patientPrimaryDetails";
import { getPatientDetailsFor } from "../../../redux/slice/singlePatientSlice";
import { fetchOrdersFromFirebaseForPatientWithId } from "../../../redux/slice/ordersForPatientSlice";
import PatientOrdersTable from "./components/patientOrdersTable/patientOrdersTable";

const SinglePatientComponent = () => {
  const { patientId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { data: singlePatient } = useSelector(
    (state: RootState) => state.singlePatient,
  );
  const { data: providerInfo } = useSelector(
    (state: RootState) => state.providerDetails,
  );
  const [primaryDetails, setPrimaryDetails] = useState<
    | {
        headerText: string;
        subText: string;
      }[]
    | null
  >(null);
  const [patientDetails, setPatientDetails] = useState<PatientDetails | null>(
    null,
  );

  useEffect(() => {
    if (patientId && providerInfo)
      dispatch(getPatientDetailsFor(providerInfo?.FacilityId || "", patientId));
  }, [patientId, providerInfo, dispatch]);

  useEffect(() => {
    if (singlePatient) {
      const getPatientData = generatePatientDataForSinglePatient(singlePatient);
      dispatch(
        fetchOrdersFromFirebaseForPatientWithId(getPatientData?.patientId),
      );
      setPatientDetails(getPatientData);
      setPrimaryDetails(
        generatePatientDataForPrimaryDetailsComponent(
          getPatientData as PatientDetails,
        ),
      );
    }
  }, [singlePatient]);

  const navigate = useNavigate();

  return (
    <div className="single-patient--layout">
      <div
        className="single-patient--header"
        onClick={() => navigate("/patients")}
      >
        <BackArrowBlue />
        Back to Patients
      </div>

      <div className="single-patient--content">
        <div className="single-patient--content--primary">
          <PatientPrimaryDetails
            primaryDetails={primaryDetails}
            patientIdentifierData={patientDetails}
          />
        </div>
        <div className="single-patient--content--table">
          <div className="single-patient--content--table--header">
            Authorizations
          </div>
          <PatientOrdersTable tableName={patientId || ""} />
        </div>
      </div>
    </div>
  );
};

export default SinglePatientComponent;
